import { CrudState } from "@/store/Crud/State";
import { ArchiveState } from "@/store/Crud/functions/archived/State";
export class State extends ArchiveState {}
